<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      :title="newBimEngineeringChange.title"
      :id="newBimEngineeringChange.id"
      :close="close"
    >
    </MapModal>
    <el-dialog
      title="文件列表"
      :modal="false"
      :visible.sync="dialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
    >
      <el-table
        :data="fileList"
        @row-click="rowClick"
        style="width: 100%"
        height="250"
      >
        <el-table-column>
          <template slot="header" slot-scope="scope">
            <div class="header">
              <span>编号：{{ number }}</span>
              <span>变更时间：{{ time.split(" ")[0] }}</span>
            </div></template
          >
          <template slot-scope="scope">{{ scope.row.fileOriginName }}</template>
        </el-table-column>
      </el-table>
      <!-- <div v-for="item in fileList" :key="item.id">{{item.fileOriginName}}</div> -->
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>

    <PDF ref="PDF" :src="pdfSrc"></PDF>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const PDF = () => import("@/components/common/pdf/Index.vue");
import { getBimDataBankDataTreeNodeList } from "@/api/api";

export default {
  name: "newBimEngineeringChange",
  components: { MapModal, PDF },
  props: {
    close: Function,
  },
  data() {
    return {
      graphicLayer: [],
      pdfSrc: null,
      fileList: [],
      number: null,
      time: null,
      dialogVisible: false,
      newBimEngineeringChange: {
        title: "变更管理",
        id: "newBimEngineeringChange", // id和ref使用的同一个
      },
      modalNode: {
        newBimEngineeringChange: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 106,
            y: -376,
            // unit: "px", // 默认px
          },
          // width: "450px", // 宽度配置 默认450px
          height: "850px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "newBimEngineeringChangeTree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            i_icon: {
              level_1: "las la-folder-open",
              level_2: "las la-file-alt",
              // level_3: "el-icon-video-pause",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            search: {
              //不需要搜索直接不传
              // type: "", //暂时无用 预留字段 后期配置 判断是否是ajax
              keywords: "text", // 搜素配置关键字 默认是name
              // filterNode: this.filterNode, // 搜索的逻辑 可以自己配置
            },
            expandClick: true,
            // nodeClick 事件绑定
            nodeClick: this.nodeClick,
          },
          //模态框foot配置
        },
      },
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    // 自定义方法
    toggleFold(item, state) {
      item.state = state;
    },
    filterNode(value, data, node) {
      console.log("搜素自己逻辑,以后会和ajax配合使用");
    },
    // 节点被点击时的回调
    nodeClick(data) {
      console.log("节点被点击时的回调");
      console.log(data);
    },
    videoSurveilClick() {
      console.log("老方法 触发关闭");
      console.log(this.$GLOBAL.markDrawGraphicLayer2);
      if (this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer.clear();
      }

      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.$emit("videoSurveilBox_close");
    },
    // 编辑
    handleEdit(data, node) {
      console.log(data);
      console.log(node);
      // if(ref.currentNode)
      //    console.log(ref.currentNode.node);
      // console.log(this.$refs.zhang.submitData);
      this.renewState = "edit";
      this.ifSort = true;
      let { name } = data.form;
      this.$refs.zhang.submitData.parentId = "0";
      this.$refs.zhang.submitData.name = name;

      // this.$refs.zhang.submitData = data.id;
    },
    // 删除
    handleDelete(data) {
      console.log(data);
    },
    rowClick(item) {
      this.dialogVisible = false;
      this.$refs.PDF.isShow = true;

      this.pdfSrc =
        process.env.VUE_APP_LOCAL_RESOURCES_PATH +
        item.filePath +
        "/" +
        item.fileObjectName;
    },
    unpackData(data) {
      data.forEach((item) => {
        item.children.forEach((i) => {
          i.operate = [
            //操作按钮
            {
              i_icon: "small-operation-btn el-icon-view",
              click: this.viewDetails,
            },
          ];
        });
      });
      this.modalNode.newBimEngineeringChange.content.treeDataJson = data;
    },
    viewDetails(item) {
      console.log(item);
      if (item.bimDataBankData.fileList.length >= 1) {
        this.number = item.text;
        this.time = item.bimDataBankData.registerTime;
        this.dialogVisible = true;
        this.fileList = item.bimDataBankData.fileList;
      } else {
        this.$message({
          message: "暂无附件",
          type: "warning",
          duration: 1500,
        });
      }
    },
    // 初始化
    init() {
      getBimDataBankDataTreeNodeList({
        projectId: window.sessionStorage.getItem("nowProjectId"),
      }).then((res) => {
        console.log(res);
        this.unpackData(res.data.data);
      });
    },
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    this.init();
  },
  watch: {},
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #606266;
}
.button {
  margin: 20px;
  width: 20em;
  position: absolute;
  top: 3em;
  left: 16em;
  appearance: none;
  // background: #f72359;
  background: #409eff;
  padding: 0.5em 1em;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  border-radius: 4px;
  span {
    position: relative;
  }
  &::before {
    --size: 0;
    content: "";
    position: absolute;
    left: var(--x);
    top: var(--y);
    width: var(--size);
    height: var(--size);
    // background: radial-gradient(circle closest-side, #4405f7, transparent);
    background: radial-gradient(circle closest-side, #ded2ff, transparent);
    transform: translate(-50%, -50%);
    transition: width 0.2s ease, height 0.2s ease;
  }
  &:hover::before {
    --size: 400px;
  }
}
.el-table /deep/tbody tr {
  cursor: pointer;
}
/deep/ .el-table--scrollable-y .el-table__body-wrapper {
  height: 201px !important;
}
</style>
